/* ========================================
   RUBICON LIGHTING - QUOTE REQUEST SYSTEM
   ======================================== */

var RQ_DEBUG = false; // set true to re-enable verbose [RubiconQuote] console logging
function rqLog() { if (RQ_DEBUG) { try { console.log.apply(console, arguments); } catch (e) {} } }

rqLog('[RubiconQuote] Script loaded');

(function() {
  'use strict';

  rqLog('[RubiconQuote] IIFE executing');

  // ========================================
  // CONFIGURATION
  // ========================================

  const CONFIG = {
    storageKey: 'rubicon_quote',
    maxQuantity: 999,
    minQuantity: 1,
    animationDuration: 300
  };

  // ========================================
  // SVG ICONS
  // ========================================

  const ICONS = {
    quote: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
    </svg>`,
    close: `&times;`,
    remove: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>`,
    empty: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
    </svg>`,
    success: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>`,
    addQuote: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
    </svg>`
  };

  // ========================================
  // STATE MANAGEMENT
  // ========================================

  const QuoteState = {
    items: [],
    isOpen: false,
    isSubmitting: false,
    showSuccess: false,

    load() {
      try {
        const stored = localStorage.getItem(CONFIG.storageKey);
        if (stored) {
          const data = JSON.parse(stored);
          this.items = data.items || [];
        }
      } catch (e) {
        console.error('Error loading quote state:', e);
        this.items = [];
      }
    },

    save() {
      try {
        const data = {
          items: this.items,
          updatedAt: new Date().toISOString()
        };
        localStorage.setItem(CONFIG.storageKey, JSON.stringify(data));
      } catch (e) {
        console.error('Error saving quote state:', e);
      }
    },

    addItem(item) {
      const existingIndex = this.items.findIndex(i => i.variantId === item.variantId);
      if (existingIndex > -1) {
        this.items[existingIndex].quantity += item.quantity;
        if (this.items[existingIndex].quantity > CONFIG.maxQuantity) {
          this.items[existingIndex].quantity = CONFIG.maxQuantity;
        }
      } else {
        this.items.push({ ...item, addedAt: new Date().toISOString() });
      }
      this.save();
    },

    updateQuantity(variantId, quantity) {
      const item = this.items.find(i => i.variantId === variantId);
      if (item) {
        item.quantity = Math.max(CONFIG.minQuantity, Math.min(CONFIG.maxQuantity, quantity));
        this.save();
      }
    },

    removeItem(variantId) {
      this.items = this.items.filter(i => i.variantId !== variantId);
      this.save();
    },

    clear() {
      this.items = [];
      this.save();
    },

    getItemCount() {
      return this.items.reduce((sum, item) => sum + item.quantity, 0);
    }
  };

  // ========================================
  // UI COMPONENTS
  // ========================================

  function createDrawerHTML() {
    return `
      <div id="rubicon-quote-drawer" class="rq-drawer">
        <div class="rq-drawer-overlay"></div>
        <div class="rq-drawer-panel">
          <header class="rq-drawer-header">
            <h2>Quote Request</h2>
            <button class="rq-close-btn" aria-label="Close">${ICONS.close}</button>
          </header>
          <div class="rq-drawer-body">
            <!-- Content rendered dynamically -->
          </div>
        </div>
      </div>
    `;
  }

  function createFloatingButtonHTML() {
    return `
      <button id="rubicon-quote-toggle" class="rq-floating-btn" aria-label="Open quote request">
        ${ICONS.quote}
        <span class="rq-badge" data-count="0">0</span>
      </button>
    `;
  }

  function renderEmptyState() {
    return `
      <div class="rq-empty-state">
        ${ICONS.empty}
        <p>Your quote list is empty.<br>Add products to request a quote.</p>
      </div>
    `;
  }

  function renderSuccessState() {
    return `
      <div class="rq-success-message">
        ${ICONS.success}
        <h3>Quote Request Sent!</h3>
        <p>We'll get back to you shortly with your quote.</p>
        <button class="rq-continue-btn" onclick="RubiconQuote.closeDrawer()">Continue Shopping</button>
      </div>
    `;
  }

  function renderItemsList() {
    if (QuoteState.items.length === 0) {
      return renderEmptyState();
    }

    const itemsHTML = QuoteState.items.map(item => `
      <div class="rq-item" data-variant-id="${item.variantId}">
        <div class="rq-item-image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="rq-item-details">
          <h4 class="rq-item-title">${escapeHTML(item.title)}</h4>
          ${item.variantTitle && item.variantTitle !== 'Default Title' ? `<p class="rq-item-variant">${escapeHTML(item.variantTitle)}</p>` : ''}
          <div class="rq-quantity-controls">
            <button class="rq-qty-btn" data-action="decrease" aria-label="Decrease quantity">-</button>
            <input type="number" class="rq-qty-input" value="${item.quantity}" min="${CONFIG.minQuantity}" max="${CONFIG.maxQuantity}" aria-label="Quantity">
            <button class="rq-qty-btn" data-action="increase" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button class="rq-remove-btn" data-action="remove" aria-label="Remove item">
          ${ICONS.remove}
        </button>
      </div>
    `).join('');

    const formHTML = `
      <div class="rq-form-section">
        <h3>Contact Details</h3>
        <form class="rq-contact-form" id="rq-contact-form">
          <div class="rq-form-row">
            <div class="rq-form-field">
              <label for="rq-name">First Name *</label>
              <input type="text" id="rq-name" name="name" required placeholder="John">
            </div>
            <div class="rq-form-field">
              <label for="rq-surname">Surname *</label>
              <input type="text" id="rq-surname" name="surname" required placeholder="Doe">
            </div>
          </div>
          <div class="rq-form-field">
            <label for="rq-email">Email *</label>
            <input type="email" id="rq-email" name="email" required placeholder="john@example.com">
          </div>
          <div class="rq-form-field">
            <label for="rq-phone">Phone Number *</label>
            <input type="tel" id="rq-phone" name="phone" required placeholder="+1 234 567 8900">
          </div>
          <div class="rq-form-field">
            <label for="rq-company">Company Name *</label>
            <input type="text" id="rq-company" name="company" required placeholder="Company Ltd">
          </div>
          <div class="rq-form-field">
            <label for="rq-comments">Comments / Notes</label>
            <textarea id="rq-comments" name="comments" rows="3" placeholder="Any additional requirements or notes..."></textarea>
          </div>
          <button type="submit" class="rq-submit-btn" id="rq-submit-btn">
            Send Quote Request
          </button>
        </form>
      </div>
    `;

    return `
      <div class="rq-items-list">${itemsHTML}</div>
      ${formHTML}
    `;
  }

  function renderDrawerContent() {
    const body = document.querySelector('#rubicon-quote-drawer .rq-drawer-body');
    if (!body) return;

    if (QuoteState.showSuccess) {
      body.innerHTML = renderSuccessState();
    } else {
      body.innerHTML = renderItemsList();
      attachFormListeners();
      attachItemListeners();
    }
  }

  function updateBadge() {
    const badge = document.querySelector('.rq-badge');
    if (badge) {
      const count = QuoteState.getItemCount();
      badge.textContent = count;
      badge.setAttribute('data-count', count);

      // Pulse animation
      badge.classList.remove('rq-badge-pulse');
      void badge.offsetWidth; // Force reflow
      badge.classList.add('rq-badge-pulse');
    }
  }

  // ========================================
  // EVENT HANDLERS
  // ========================================

  function attachFormListeners() {
    const form = document.getElementById('rq-contact-form');
    if (form) {
      form.addEventListener('submit', handleFormSubmit);
    }
  }

  function attachItemListeners() {
    const itemsList = document.querySelector('.rq-items-list');
    if (!itemsList) return;

    // Quantity controls
    itemsList.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;

      const item = btn.closest('.rq-item');
      const variantId = item?.dataset.variantId;
      if (!variantId) return;

      const action = btn.dataset.action;
      const input = item.querySelector('.rq-qty-input');
      const currentQty = parseInt(input?.value) || 1;

      switch (action) {
        case 'increase':
          QuoteState.updateQuantity(variantId, currentQty + 1);
          break;
        case 'decrease':
          QuoteState.updateQuantity(variantId, currentQty - 1);
          break;
        case 'remove':
          QuoteState.removeItem(variantId);
          break;
      }

      renderDrawerContent();
      updateBadge();
    });

    // Manual quantity input
    itemsList.addEventListener('change', (e) => {
      if (!e.target.classList.contains('rq-qty-input')) return;

      const item = e.target.closest('.rq-item');
      const variantId = item?.dataset.variantId;
      if (!variantId) return;

      const newQty = parseInt(e.target.value) || CONFIG.minQuantity;
      QuoteState.updateQuantity(variantId, newQty);
      e.target.value = QuoteState.items.find(i => i.variantId === variantId)?.quantity || newQty;
      updateBadge();
    });
  }

  async function handleFormSubmit(e) {
    e.preventDefault();

    if (QuoteState.isSubmitting) return;

    const form = e.target;
    const submitBtn = document.getElementById('rq-submit-btn');

    // Validate form
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // Get form data
    const formData = {
      name: form.name.value.trim(),
      surname: form.surname.value.trim(),
      email: form.email.value.trim(),
      phone: form.phone.value.trim(),
      company: form.company.value.trim(),
      comments: form.comments.value.trim()
    };

    // Build quote message
    const quoteLines = QuoteState.items.map(item => {
      let line = `- ${item.title}`;
      if (item.variantTitle && item.variantTitle !== 'Default Title') {
        line += ` (${item.variantTitle})`;
      }
      line += ` x ${item.quantity}`;
      if (item.price) {
        line += ` @ $${item.price}`;
      }
      return line;
    });

    const messageBody = `
QUOTE REQUEST

Contact Information:
- Name: ${formData.name} ${formData.surname}
- Email: ${formData.email}
- Phone: ${formData.phone}
- Company: ${formData.company}

Requested Items:
${quoteLines.join('\n')}

Total Items: ${QuoteState.getItemCount()}
${formData.comments ? `
Comments / Notes:
${formData.comments}
` : ''}
---
Submitted via Rubicon Quote System
    `.trim();

    // Show loading state
    QuoteState.isSubmitting = true;
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="rq-spinner"></span> Sending...';

    rqLog('[RubiconQuote] Starting quote submission...');

    try {
      // Try multiple methods to get CSRF token
      let authenticityToken = null;

      // Method 1: Try to get from current page DOM
      const existingToken = document.querySelector('input[name="authenticity_token"]');
      if (existingToken) {
        authenticityToken = existingToken.value;
        rqLog('[RubiconQuote] Got CSRF token from current page');
      }

      // Method 2: Fetch contact page with credentials (maintains session)
      if (!authenticityToken) {
        rqLog('[RubiconQuote] Fetching contact page for CSRF token...');
        const contactPageResponse = await fetch('/contact', {
          credentials: 'same-origin'
        });
        const contactPageHTML = await contactPageResponse.text();

        // Extract authenticity token from the page
        const tokenMatch = contactPageHTML.match(/name="authenticity_token"\s+value="([^"]+)"/);
        authenticityToken = tokenMatch ? tokenMatch[1] : null;
      }

      // Method 3: Try getting from any form on the page
      if (!authenticityToken) {
        const anyForm = document.querySelector('form input[name="authenticity_token"]');
        if (anyForm) {
          authenticityToken = anyForm.value;
          rqLog('[RubiconQuote] Got CSRF token from page form');
        }
      }

      rqLog('[RubiconQuote] Authenticity token found:', !!authenticityToken);

      // Build form data with all required fields
      const submitData = new URLSearchParams({
        'form_type': 'contact',
        'utf8': '✓',
        'contact[name]': `${formData.name} ${formData.surname}`,
        'contact[email]': formData.email,
        'contact[phone]': formData.phone,
        'contact[company]': formData.company,
        'contact[body]': messageBody
      });

      // Add authenticity token if found
      if (authenticityToken) {
        submitData.append('authenticity_token', authenticityToken);
      }

      rqLog('[RubiconQuote] Submitting quote request...');

      // Submit the form
      const response = await fetch('/contact#contact_form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: submitData.toString()
      });

      rqLog('[RubiconQuote] Response status:', response.status);

      // Check if submission was successful
      const responseText = await response.text();

      // A 400 or 422 status typically means form validation error or missing CSRF
      if (response.status === 400 || response.status === 422) {
        console.error('[RubiconQuote] Form submission failed with status:', response.status);
        rqLog('[RubiconQuote] Response body preview:', responseText.substring(0, 500));
        throw new Error('Form submission failed. Please try again or contact us directly.');
      }

      // Check for common error indicators in Shopify's response
      const hasError = responseText.includes('error') &&
                       (responseText.includes('contact[email]') ||
                        responseText.includes('form--error') ||
                        responseText.includes('errors'));

      // Check for success indicators
      const hasSuccess = responseText.includes('Thank') ||
                         responseText.includes('success') ||
                         responseText.includes('received') ||
                         response.redirected ||
                         response.status === 200;

      rqLog('[RubiconQuote] Response analysis - hasError:', hasError, 'hasSuccess:', hasSuccess);

      if (hasError && !hasSuccess) {
        console.error('[RubiconQuote] Form submission returned errors');
        throw new Error('The contact form returned an error. Please check your details and try again.');
      }

      // If we got here without obvious errors, consider it successful
      rqLog('[RubiconQuote] Quote submitted successfully!');
      QuoteState.showSuccess = true;
      QuoteState.clear();
      renderDrawerContent();
      updateBadge();

    } catch (error) {
      console.error('[RubiconQuote] Quote submission error:', error);

      // Show more helpful error message
      const errorMessage = error.message || 'There was an error sending your quote request.';
      alert(errorMessage + '\n\nPlease try again or contact us directly at the email shown on our contact page.');
    } finally {
      QuoteState.isSubmitting = false;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Send Quote Request';
      }
    }
  }

  // ========================================
  // ADD TO QUOTE BUTTON INJECTION
  // ========================================

  function injectAddToQuoteButton() {
    // Strategy: Find visible product areas to inject the button
    // The Add to Cart and Price sections may be hidden
    // We don't require a form - we get product data from ShopifyAnalytics

    rqLog('[RubiconQuote] Starting button injection...');

    // Check if button already exists
    if (document.querySelector('.rq-add-to-quote-btn')) {
      rqLog('[RubiconQuote] Button already exists');
      return;
    }

    // Check if we're on a product page by looking for product data
    const productData = window.ShopifyAnalytics?.meta?.product;
    if (!productData) {
      rqLog('[RubiconQuote] Not a product page or no product data');
      return;
    }

    rqLog('[RubiconQuote] Product found:', productData.handle);

    // Create Add to Quote button
    const quoteBtn = document.createElement('button');
    quoteBtn.type = 'button';
    quoteBtn.className = 'rq-add-to-quote-btn';
    quoteBtn.innerHTML = `${ICONS.addQuote} Add to Quote`;

    quoteBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleAddToQuote(null, quoteBtn);
    });

    // Create wrapper for proper styling
    const wrapper = document.createElement('div');
    wrapper.className = 'productView-moreItem rq-button-wrapper';
    wrapper.style.cssText = 'margin-top: 20px; margin-bottom: 20px; width: 100%;';
    wrapper.appendChild(quoteBtn);

    // Halo theme specific selectors - try these exact elements
    const selectors = [
      // The product title h1 element - insert after its parent moreItem wrapper
      'h1.productView-title',
      // Variant picker section
      '.productView-moreItem-product-variant',
      // Product vendor section
      '.product__vendor',
      // Product info/meta section
      '.productView-meta',
      // Any visible moreItem
      '.productView-moreItem',
      // Product content area
      '.productView-product',
      // Right side panel
      '.halo-productView-right',
      '.productView-details'
    ];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        // Check if element or its parent is visible
        const checkEl = element.closest('.productView-moreItem') || element;
        const style = window.getComputedStyle(checkEl);

        rqLog('[RubiconQuote] Checking:', selector, '- display:', style.display, 'visibility:', style.visibility);

        if (style.display !== 'none' && style.visibility !== 'hidden') {
          // For h1.productView-title, insert after its parent wrapper
          const insertTarget = element.closest('.productView-moreItem') || element;
          insertTarget.insertAdjacentElement('afterend', wrapper);
          rqLog('[RubiconQuote] Button injected after:', selector);
          return;
        }
      }
    }

    // Last resort: append to productView-product or details area
    const fallbackContainer = document.querySelector('.productView-product') ||
                              document.querySelector('.halo-productView-right') ||
                              document.querySelector('.productView-details');

    if (fallbackContainer) {
      fallbackContainer.appendChild(wrapper);
      rqLog('[RubiconQuote] Button appended to fallback container');
      return;
    }

    rqLog('[RubiconQuote] No suitable injection point found');
  }

  function getSelectedOptionsFromPage() {
    const selectedOptions = [];

    // Method 1: Look for ANY elements showing "Option: Value" format anywhere in product info
    // Search broadly in the product area for text patterns like "Wattage: 25W"
    const productArea = document.querySelector('.productView, .product-single, .product-template, .product__info-wrapper, main') || document.body;

    // Look for elements with text matching "Something: Value" pattern
    const allTextElements = productArea.querySelectorAll('label, span, p, div.form-label, .form-field-title, [class*="option"], [class*="variant"], [class*="swatch"] > span');
    allTextElements.forEach(el => {
      // Skip if element has too many children (likely a container)
      if (el.children.length > 3) return;

      const text = el.textContent?.trim();
      if (text && text.includes(':') && text.length < 50) {
        const value = text.split(':').slice(1).join(':').trim();
        if (value && value !== 'Default Title' && !selectedOptions.includes(value)) {
          selectedOptions.push(value);
        }
      }
    });

    // Also specifically look for Halo theme's form labels
    document.querySelectorAll('.productView-options .form-label, .form-field-title, .product-form__option-name').forEach(label => {
      const text = label.textContent?.trim();
      if (text && text.includes(':')) {
        const value = text.split(':').slice(1).join(':').trim();
        if (value && value !== 'Default Title' && !selectedOptions.includes(value)) {
          selectedOptions.push(value);
        }
      }
    });

    // Method 2: Look for elements that display the selected value with data attributes
    if (selectedOptions.length === 0) {
      document.querySelectorAll('[data-header-option], [data-option-value], .selected-option').forEach(el => {
        const value = el.textContent?.trim();
        if (value && value !== 'Default Title' && !selectedOptions.includes(value)) {
          selectedOptions.push(value);
        }
      });
    }

    // Method 3: Look for active/checked swatch inputs and get their values
    if (selectedOptions.length === 0) {
      document.querySelectorAll('input[type="radio"]:checked, input.swatch-input:checked').forEach(input => {
        if (input.name !== 'id' && input.name !== 'quantity') {
          const value = input.value || input.getAttribute('data-value');
          if (value && value !== 'Default Title' && !selectedOptions.includes(value)) {
            selectedOptions.push(value);
          }
        }
      });
    }

    // Method 4: Look for active swatch elements by class
    if (selectedOptions.length === 0) {
      const activeSelectors = [
        '.swatch-element.is-active',
        '.swatch-element.is-selected',
        '.swatch.is-active',
        '.swatch.active',
        '.variant-swatch.active',
        '.product-form__swatch.is-active'
      ];
      activeSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          const value = el.getAttribute('data-value') || el.getAttribute('data-title') || el.querySelector('label')?.textContent?.trim() || el.textContent?.trim();
          if (value && value !== 'Default Title' && !selectedOptions.includes(value)) {
            selectedOptions.push(value);
          }
        });
      });
    }

    // Method 5: Look for selected dropdowns
    if (selectedOptions.length === 0) {
      document.querySelectorAll('.productView-options select, .variant-wrapper select, .product-form__input select').forEach(select => {
        if (select.name !== 'id' && select.name !== 'quantity') {
          const value = select.options?.[select.selectedIndex]?.text || select.value;
          if (value && value !== 'Default Title' && !selectedOptions.includes(value)) {
            selectedOptions.push(value);
          }
        }
      });
    }

    // Method 6: Get from SKU which often contains variant info (e.g., "MINILEAN-25W-WHT")
    if (selectedOptions.length === 0) {
      const skuEl = document.querySelector('.productView-info-value[data-sku], .product-sku, [class*="sku"]');
      const sku = skuEl?.textContent?.trim();
      if (sku) {
        // Try to extract meaningful parts from SKU (e.g., "25W", "WHT" -> "White")
        const skuParts = sku.split('-').slice(1); // Remove product code prefix
        if (skuParts.length > 0) {
          selectedOptions.push(...skuParts);
        }
      }
    }

    rqLog('[RubiconQuote] Selected options from page:', selectedOptions);
    return selectedOptions.filter(Boolean).join(' / ');
  }

  function handleAddToQuote(form, button) {
    rqLog('[RubiconQuote] Add to Quote clicked');
    // Get product data from the page
    const productData = getProductDataFromForm(form);
    rqLog('[RubiconQuote] Product data:', productData);

    if (!productData) {
      console.error('Could not get product data');
      return;
    }

    // Add to quote state
    QuoteState.addItem(productData);
    updateBadge();

    // Refresh drawer if it's open
    if (QuoteState.isOpen) {
      renderDrawerContent();
    }

    // Visual feedback - show variant if available
    const originalHTML = button.innerHTML;
    button.classList.add('rq-added');

    let feedbackText = '✓ Added to Quote';
    if (productData.variantTitle && productData.variantTitle !== 'Default Title') {
      feedbackText = `✓ Added: ${productData.variantTitle}`;
    }
    button.innerHTML = feedbackText;

    setTimeout(() => {
      button.classList.remove('rq-added');
      button.innerHTML = originalHTML;
    }, 2000);
  }

  function getProductDataFromForm(form) {
    // Try to get variant ID from form, URL, or ShopifyAnalytics
    let variantId = null;

    // Try form first if available
    if (form) {
      const variantInput = form.querySelector('[name="id"], input[name="id"]');
      const variantSelect = form.querySelector('select[name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      } else if (variantSelect) {
        variantId = variantSelect.value;
      }
    }

    // Try URL params
    if (!variantId) {
      const urlParams = new URLSearchParams(window.location.search);
      variantId = urlParams.get('variant');
    }

    // Try to get variant ID from hidden input on page
    if (!variantId) {
      const hiddenVariantInput = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
      if (hiddenVariantInput) {
        variantId = hiddenVariantInput.value;
      }
    }

    // Try to get first variant from ShopifyAnalytics
    if (!variantId) {
      const productMeta = window.ShopifyAnalytics?.meta?.product;
      if (productMeta?.variants?.length > 0) {
        variantId = productMeta.variants[0].id?.toString();
      }
    }

    // Get quantity from form or default to 1
    let quantity = 1;
    if (form) {
      const quantityInput = form.querySelector('[name="quantity"], input[type="number"]');
      quantity = parseInt(quantityInput?.value) || 1;
    }

    // Get product info from the page
    let productTitle = '';
    let variantTitle = '';
    let price = '';
    let image = '';
    let productId = '';

    // Try to get full product JSON from script tag (most reliable for variant data)
    let productJSON = null;
    const productJsonScript = document.querySelector('script[data-product-json], script[id="ProductJson"], script[type="application/json"][data-product]');
    if (productJsonScript) {
      try {
        productJSON = JSON.parse(productJsonScript.textContent);
        rqLog('[RubiconQuote] Found product JSON in script tag');
      } catch (e) {
        rqLog('[RubiconQuote] Failed to parse product JSON from script');
      }
    }

    // Fallback to window objects
    if (!productJSON) {
      productJSON = window.productJson || window.product || window.ShopifyAnalytics?.meta?.product;
    }

    if (productJSON) {
      productId = productJSON.id?.toString() || '';
      productTitle = productJSON.title || '';

      // Find the selected variant
      const variant = productJSON.variants?.find(v => v.id?.toString() === variantId);
      if (variant) {
        variantTitle = variant.title || '';
        // Handle price - could be in cents or dollars depending on source
        if (typeof variant.price === 'number') {
          price = variant.price > 1000 ? (variant.price / 100).toFixed(2) : variant.price.toFixed(2);
        } else if (variant.price) {
          price = variant.price.toString().replace(/[^0-9.]/g, '');
        }
        image = variant.featured_image?.src || variant.image || productJSON.featured_image || '';
      } else {
        if (productJSON.price) {
          price = productJSON.price > 1000 ? (productJSON.price / 100).toFixed(2) : productJSON.price.toString();
        }
        image = productJSON.featured_image || '';
      }
    }

    // Fallback: Try to scrape from page elements (Halo theme selectors)
    if (!productTitle) {
      const titleEl = document.querySelector('.productView-title, .product__title, .product-single__title, h1.title, [data-product-title], .product-title');
      productTitle = titleEl?.textContent?.trim() || 'Product';
    }

    // ALWAYS try to get variant title from the page UI as it's most reliable
    // This captures what the user actually selected
    const selectedOptionsFromPage = getSelectedOptionsFromPage();
    if (selectedOptionsFromPage && selectedOptionsFromPage !== 'Default Title') {
      variantTitle = selectedOptionsFromPage;
      rqLog('[RubiconQuote] Got variant from page UI:', variantTitle);
    }


    if (!price) {
      const priceEl = document.querySelector('.productView-price .money, .product-price .money, .product__price .money, .price__regular .money, [data-product-price], .price-item--regular, .price .money');
      const priceText = priceEl?.textContent?.trim() || '';
      price = priceText.replace(/[^0-9.]/g, '');
    }

    if (!image) {
      const imgEl = document.querySelector('.productView-image img, .product-single__photo img, .product__media img, [data-product-image], .product-featured-image');
      image = imgEl?.src || '';
    }

    if (!variantId) {
      console.error('No variant ID found');
      return null;
    }

    return {
      productId,
      variantId,
      title: productTitle,
      variantTitle,
      price,
      quantity,
      image
    };
  }

  // ========================================
  // DRAWER CONTROLS
  // ========================================

  function openDrawer() {
    const drawer = document.getElementById('rubicon-quote-drawer');
    if (drawer) {
      QuoteState.showSuccess = false;
      QuoteState.isOpen = true;
      renderDrawerContent();
      drawer.classList.add('rq-drawer-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer() {
    const drawer = document.getElementById('rubicon-quote-drawer');
    if (drawer) {
      QuoteState.isOpen = false;
      drawer.classList.remove('rq-drawer-open');
      document.body.style.overflow = '';
    }
  }

  function toggleDrawer() {
    if (QuoteState.isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  // ========================================
  // UTILITIES
  // ========================================

  function escapeHTML(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ========================================
  // INITIALIZATION
  // ========================================

  function init() {
    // Load saved state
    QuoteState.load();

    // Inject drawer HTML
    document.body.insertAdjacentHTML('beforeend', createDrawerHTML());
    document.body.insertAdjacentHTML('beforeend', createFloatingButtonHTML());

    // Update badge with current count
    updateBadge();

    // Attach drawer event listeners
    const toggleBtn = document.getElementById('rubicon-quote-toggle');
    const drawer = document.getElementById('rubicon-quote-drawer');
    const closeBtn = drawer?.querySelector('.rq-close-btn');
    const overlay = drawer?.querySelector('.rq-drawer-overlay');

    toggleBtn?.addEventListener('click', toggleDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && QuoteState.isOpen) {
        closeDrawer();
      }
    });

    // Inject Add to Quote buttons with retry for dynamic content
    injectAddToQuoteButton();

    // Retry injection after short delays to catch dynamically loaded content
    setTimeout(injectAddToQuoteButton, 500);
    setTimeout(injectAddToQuoteButton, 1000);
    setTimeout(injectAddToQuoteButton, 2000);

    // Re-inject buttons when dynamic content loads (for SPAs/AJAX)
    const observer = new MutationObserver((mutations) => {
      // Debounce mutation observer
      clearTimeout(window._rqInjectTimeout);
      window._rqInjectTimeout = setTimeout(injectAddToQuoteButton, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    rqLog('Rubicon Quote System initialized');
  }

  // ========================================
  // PUBLIC API
  // ========================================

  window.RubiconQuote = {
    openDrawer,
    closeDrawer,
    toggleDrawer,
    addItem: (item) => {
      QuoteState.addItem(item);
      updateBadge();
    },
    removeItem: (variantId) => {
      QuoteState.removeItem(variantId);
      updateBadge();
      if (QuoteState.isOpen) renderDrawerContent();
    },
    clearQuote: () => {
      QuoteState.clear();
      updateBadge();
      if (QuoteState.isOpen) renderDrawerContent();
    },
    getItems: () => [...QuoteState.items],
    getItemCount: () => QuoteState.getItemCount()
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ========================================
   RUBICON QUOTE — "Add to Quote" CTA buttons rendered in Liquid
   (quick view / quick shop / product cards). Uses event delegation so it
   works for AJAX-loaded modals where inline scripts don't execute.
   Buttons are marked with [data-rq-quote-add] and carry product/variant data.
   Added 2026-05-27.
   ======================================== */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rq-quote-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!window.RubiconQuote || typeof window.RubiconQuote.addItem !== 'function') return;

    var form = btn.closest('form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var variantId = (idInput && idInput.value) || btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var title = btn.getAttribute('data-title') || 'Product';
    var productId = btn.getAttribute('data-product-id') || '';
    var image = btn.getAttribute('data-image') || '';
    var price = btn.getAttribute('data-price') || '';
    var variantTitle = '';

    var raw = btn.getAttribute('data-variants');
    if (raw) {
      try {
        var variants = JSON.parse(raw);
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            var v = variants[i];
            if (v.title && v.title !== 'Default Title') variantTitle = v.title;
            if (typeof v.price === 'number') price = (v.price / 100).toFixed(2);
            if (v.featured_image && v.featured_image.src) image = v.featured_image.src;
            break;
          }
        }
      } catch (err) {}
    }

    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    window.RubiconQuote.addItem({
      productId: productId,
      variantId: String(variantId),
      title: title,
      variantTitle: variantTitle,
      price: price,
      quantity: quantity,
      image: image
    });

    var original = btn.innerHTML;
    btn.classList.add('rq-added');
    btn.innerHTML = variantTitle ? ('✓ Added: ' + variantTitle) : '✓ Added to Quote';
    setTimeout(function () {
      btn.classList.remove('rq-added');
      btn.innerHTML = original;
    }, 2000);
  });
})();
